import Template from '../../../component/Template.js';
import React, { useEffect, useRef, useState } from 'react';
import Api from '../../../component/Api.js';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../component/useAuth.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PDFModal from '../../../component/PDFModal.js';
import 'datatables.net';
import Swal from 'sweetalert2';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import ViewApplicationModal from '../../../component/ExternalCredit/ViewExternalCreditApplication.js';
import useViewApplicationModal from '../../../component/ExternalCredit/useViewApplication.js';
import ViewExternalCreditApplicationUpdate from '../../../component/ExternalCredit/ViewExternalCreditApplicationUpdate.js';
import ExportExternalCreditModal from './ExportExternalCreditModal.js';
import Select from 'react-select';
import $ from 'jquery';

// ─── ActionBtn ────────────────────────────────────────────────────────────────
const ActionBtn = ({ onClick, title, borderColor, hoverBg, hoverColor, icon, baseColor }) => {
    const base = {
        background: '#fff',
        border: `1.5px solid ${borderColor}`,
        color: baseColor || borderColor,
        borderRadius: '6px',
        width: '28px',
        height: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        flexShrink: 0,
    };
    return (
        <button
            type="button"
            title={title}
            style={base}
            onMouseEnter={e => {
                e.currentTarget.style.background = hoverBg || borderColor;
                e.currentTarget.style.color = hoverColor || '#fff';
                e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={e => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.color = baseColor || borderColor;
                e.currentTarget.style.transform = 'scale(1)';
            }}
            onClick={onClick}
        >
            <i className={icon} style={{ fontSize: '13px', pointerEvents: 'none' }}></i>
        </button>
    );
};

// ─── ActionDropdown ───────────────────────────────────────────────────────────
const ActionDropdown = ({ item, onView, onEdit, onUpdateStatus }) => {
    const [open, setOpen] = useState(false);
    const [dropPos, setDropPos] = useState({ top: 0, left: 0 });
    const btnRef = useRef(null);
    const dropRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                btnRef.current && !btnRef.current.contains(e.target) &&
                dropRef.current && !dropRef.current.contains(e.target)
            ) setOpen(false);
        };
        const handleScroll = () => setOpen(false);
        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('scroll', handleScroll, true);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, []);

    const ROW_HEIGHT = 42;
    const VISIBLE_ROWS = 5;

    const actions = [];

    actions.push({
        label: 'View',
        icon: 'bi bi-eye-fill',
        color: '#0dcaf0',
        onClick: () => { onView(item); setOpen(false); }
    });

    if (item.application_status === 'forwarded_to_university' && item.course_approval_status === 'pending') {
        actions.push({
            label: 'Edit',
            icon: 'bi bi-pencil-fill',
            color: '#ffc107',
            onClick: () => { onEdit(item, 'aca16'); setOpen(false); }
        });
        actions.push({
            label: 'Revert to Student',
            icon: 'bi bi-arrow-counterclockwise',
            color: '#fd7e14',
            onClick: () => { onUpdateStatus(item.id, 'reverted_to_student', 'Reverted to Student'); setOpen(false); }
        });
        actions.push({
            label: 'Reject',
            icon: 'bi bi-x-lg',
            color: '#dc3545',
            onClick: () => { onUpdateStatus(item.id, 'rejected_by_aca16', 'Rejected'); setOpen(false); }
        });
    }

    if (item.application_status === 'bos_course_approved' && item.course_approval_status === 'approved') {
        actions.push({
            label: 'Approve',
            icon: 'bi bi-check-lg',
            color: '#198754',
            onClick: () => { onUpdateStatus(item.id, 'application_approved', 'Application Approved'); setOpen(false); }
        });
    }

    const dropdownHeight = Math.min(actions.length, VISIBLE_ROWS) * ROW_HEIGHT;

    const handleToggle = () => {
        if (!open && btnRef.current) {
            const rect = btnRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const flipUp = spaceBelow < dropdownHeight + 8;
            setDropPos({
                left: rect.right - 170,
                top: flipUp ? rect.top - dropdownHeight - 4 : rect.bottom + 4,
            });
        }
        setOpen(prev => !prev);
    };

    return (
        <>
            <button
                ref={btnRef}
                type="button"
                onClick={handleToggle}
                style={{
                    width: '30px', height: '30px', borderRadius: '6px',
                    border: '1.5px solid #dee2e6',
                    background: open ? '#f8f9fa' : '#fff',
                    cursor: 'pointer', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', transition: 'all 0.12s',
                }}
                title="Actions"
            >
                <i className="bi bi-three-dots-vertical" style={{ fontSize: '14px', color: '#495057', pointerEvents: 'none' }} />
            </button>

            {open && (
                <div
                    ref={dropRef}
                    style={{
                        position: 'fixed',
                        top: `${dropPos.top}px`,
                        left: `${dropPos.left}px`,
                        zIndex: 9999,
                        background: '#fff',
                        border: '0.5px solid #dee2e6',
                        borderRadius: '8px',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                        width: '170px',
                        height: `${dropdownHeight}px`,
                        overflowY: actions.length > VISIBLE_ROWS ? 'auto' : 'hidden',
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#dee2e6 transparent',
                    }}
                >
                    {actions.map((action, i) => (
                        <div
                            key={i}
                            onClick={action.onClick}
                            style={{
                                display: 'flex', alignItems: 'center', gap: '9px',
                                padding: '0 12px', height: `${ROW_HEIGHT}px`,
                                fontSize: '13px', cursor: 'pointer', color: '#212529',
                                borderBottom: i < actions.length - 1 ? '0.5px solid #f0f1f2' : 'none',
                                transition: 'background 0.1s', background: '#fff', flexShrink: 0,
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                            onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                        >
                            <div style={{
                                width: '24px', height: '24px', borderRadius: '5px',
                                background: `${action.color}18`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                <i className={action.icon} style={{ fontSize: '11px', color: action.color, pointerEvents: 'none' }} />
                            </div>
                            <span>{action.label}</span>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

// ─── Main Component ───────────────────────────────────────────────────────────
export default function ACA16ExternalCreditList() {

    const navigate = useNavigate();
    const isAuth = useAuth();
    if (isAuth === false) navigate("/admin/");

    const tableRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const { http } = Api();

    // Data states
    const [studentData, setStudentData] = useState([]);
    const [getCollegesData, setCollegesData] = useState([]);
    const [getDisciplinesData, setDisciplinesData] = useState([]);
    const [admissionYears, setAdmissionYears] = useState([]);
    const [courseTabData, setCourseTabData] = useState([]);
    const [courseTabLoading, setCourseTabLoading] = useState(false);
    const [coursesData, setCoursesData] = useState([]); // approved courses for modal
    const [isExportingCoursesDirect, setIsExportingCoursesDirect] = useState(false);
    const [isExportingExcel, setIsExportingExcel] = useState(false);
    const [showCoursesModal, setShowCoursesModal] = useState(false);

    // Filter states
    const [selectedAdmissionYearID, setSelectedAdmissionYearID] = useState('');
    const [selectedAdmissionYear, setSelectedAdmissionYear] = useState(null);
    const [changedCollegeData, setChangedCollegeData] = useState(null);
    const [changedCollegesId, setChangedCollegesId] = useState(0);
    const [changedDisciplineData, setChangedDisciplineData] = useState(null);
    const [changedDisciplineId, setChangedDisciplineId] = useState(0);
    const [statusOptions, setStatusOptions] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [appliedStatus, setAppliedStatus] = useState(null);

    // Tab state — 'application' | 'course_pending' | 'filtered'
    const [activeTab, setActiveTab] = useState('pending');

    // Application selection
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    // Course selection
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectAllCourses, setSelectAllCourses] = useState(false);

    // Datatable states
    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' });
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setFilteredAndSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total_count, setTotal] = useState(0);

    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedAccountId, setSelectedAccountId] = useState(null);
    const [selectedCreditId, setSelectedCreditId] = useState(null);
    const [selectedRole, setSelectedRole] = useState("");
    const [reload, setReload] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [pendingApplications, setPendingApplications] = useState([]);
    const [isLoadingCourses, setIsLoadingCourses] = useState(false);

    const {
        showViewModal, viewData, viewLoading, pdfLoading, pdfModal,
        openViewModal, closeViewModal, openPdfModal, closePdfModal,
    } = useViewApplicationModal(http);

    useEffect(() => {
        return () => { if (pdfModal.url) URL.revokeObjectURL(pdfModal.url); };
    }, [pdfModal.url]);

    const customStyles = {
        menu: (provided) => ({ ...provided, maxHeight: '200px', overflowY: 'auto' }),
        menuList: (provided) => ({
            ...provided, maxHeight: '200px', overflowY: 'auto',
            scrollbarWidth: 'thin', scrollbarColor: '#888 #f1f1f1',
        }),
    };

    const statusLabelMap = {
        forwarded_to_sfa: 'Submitted by Student',
        forwarded_to_principal: 'Forwarded to Principal',
        rejected_by_sfa: 'Rejected by SFA',
        rejected_by_principal: 'Rejected by Principal',
        forwarded_to_university: 'Pending',
        rejected_by_aca16: 'Rejected',
        bos_course_rejected: 'BOS Rejected',
        forwarded_to_bos: 'BOS Approval Pending',
        bos_course_approved: 'BOS Approved',
        application_approved: 'Approved',
        reverted_to_student: 'Reverted to Student',
    };

    // ── Fetch Admission Years ─────────────────────────────────────────────────
    useEffect(() => {
        const fetchAdmissionYears = async () => {
            try {
                const response = await http.get("/Admin/getActiveAdmissionYear");
                setAdmissionYears(response.data.map(year => ({
                    value: year.admission_year, label: year.admission_year,
                })));
            } catch (error) {
                console.error("Error fetching admission years:", error);
            }
        };
        fetchAdmissionYears();
    }, []);

    // ── Fetch Colleges ────────────────────────────────────────────────────────
    useEffect(() => {
        const fetchColleges = async () => {
            if (!selectedAdmissionYearID) return;
            try {
                const res = await http.get('/College/getACA16ExternalCreditColleges', {
                    params: { admissionyear: selectedAdmissionYearID }
                });
                if (res.data.colleges) setCollegesData(res.data.colleges);
            } catch (error) {
                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => navigate("/admin/"), 5000);
                } else {
                    toast.error(error.response?.data?.message || "Error fetching colleges");
                }
            }
        };
        fetchColleges();
    }, [selectedAdmissionYearID]);

    useEffect(() => {
        const fetchDisciplines = async () => {
            if (!selectedAdmissionYearID) return;
            try {
                const res = await http.get('/College/getACA16ExternalCreditDisciplines', {
                    params: {
                        admissionyear: selectedAdmissionYearID,
                        college_id: changedCollegesId || null,
                    }
                });
                if (res.data.disciplines) setDisciplinesData(res.data.disciplines);
            } catch (error) {
                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => navigate("/admin/"), 5000);
                } else {
                    toast.error(error.response?.data?.message || "Error fetching disciplines");
                }
            }
        };
        fetchDisciplines();
    }, [selectedAdmissionYearID, changedCollegesId]);

    const fetchApprovedCourses = async () => {
        if (!selectedAdmissionYearID) return;

        setIsLoadingCourses(true);
        try {
            const res = await http.get('/College/getApprovedExternalCreditCourses');
            setCoursesData(res.data.courses || []);
        } catch (error) {
            toast.error("Error fetching approved courses");
        } finally {
            setIsLoadingCourses(false);
        }
    };

    const fetchStatuses = async () => {
        try {
            const res = await http.get('/College/getApplicationStatuses');
            setStatusOptions((res.data.statuses || []).map(status => ({
                value: status,
                label: statusLabelMap[status] || status
            })));
        } catch (err) {
            toast.error("Failed to load statuses");
        }
    };

    useEffect(() => {
        if (selectedAdmissionYearID) fetchStatuses();
    }, [selectedAdmissionYearID]);

    useEffect(() => {
        let tabFilteredData = [];

        if (activeTab === 'filtered' && appliedStatus) {
            tabFilteredData = studentData;
        } else if (activeTab === 'pending') {
            tabFilteredData = pendingApplications;
        } else if (activeTab === 'application') {
            tabFilteredData = studentData;
        } else {
            tabFilteredData = [];
        }

        const filtered = tabFilteredData.filter(student => {
            if (!searchQuery) return true;
            const sq = String(searchQuery).toLowerCase();
            return (
                (student.prn ? String(student.prn).toLowerCase().includes(sq) : false) ||
                (student.studentname ? String(student.studentname).toLowerCase().includes(sq) : false) ||
                (student.apaar_no ? String(student.apaar_no).toLowerCase().includes(sq) : false) ||
                (student.course_name ? String(student.course_name).toLowerCase().includes(sq) : false) ||
                (student.discipline_name ? String(student.discipline_name).toLowerCase().includes(sq) : false)
            );
        }).sort((a, b) => {
            if (!sortBy.column) return 0;
            const valA = a[sortBy.column] != null ? String(a[sortBy.column]).toLowerCase() : '';
            const valB = b[sortBy.column] != null ? String(b[sortBy.column]).toLowerCase() : '';
            if (sortBy.direction === 'asc') return valA > valB ? 1 : valA < valB ? -1 : 0;
            return valA < valB ? 1 : valA > valB ? -1 : 0;
        });

        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;

        setFilteredAndSortedData(filtered.slice(startIndex, startIndex + itemsPerPage));
        setTotalPages(Math.ceil(filtered.length / itemsPerPage) || 1);
        setTotal(filtered.length);

    }, [searchQuery, sortBy, studentData, pendingApplications, currentPage, activeTab, appliedStatus]);

    const handleAdmissionYearChange = (selectedOption) => {
        const newYear = selectedOption.value;
        if (newYear === selectedAdmissionYearID) return;
        setSelectedAdmissionYearID(newYear);
        setSelectedAdmissionYear(selectedOption);
        setChangedCollegeData(null); setChangedCollegesId(0);
        setChangedDisciplineData(null); setChangedDisciplineId(0);
        setCollegesData([]); setDisciplinesData([]);
        setStatusOptions([]); setSelectedStatus(null);
        setStudentData([]); setSelectedStudents([]); setSelectAll(false);
        setCourseTabData([]); setSelectedCourses([]); setSelectAllCourses(false);
        setAppliedStatus(null); setCoursesData([]);
    };

    const handleStatusChange = (selected) => {
        setSelectedStatus(selected);
        setCurrentPage(1); setSelectedStudents([]); setSelectAll(false);
    };

    const handleCollegeChange = (selectedOption) => {
        setChangedCollegeData(selectedOption);
        setChangedCollegesId(selectedOption?.value || 0);
    };

    const handleDisciplineChange = (selectedOption) => {
        setChangedDisciplineData(selectedOption);
        setChangedDisciplineId(selectedOption?.value || 0);
    };

    const handleClearFields = () => {
        setSelectedAdmissionYearID(''); setSelectedAdmissionYear(null);
        setChangedCollegeData(null); setChangedCollegesId(0);
        setChangedDisciplineData(null); setChangedDisciplineId(0);
        setCollegesData([]); setDisciplinesData([]);
        setStatusOptions([]); setSelectedStatus(null);
        setStudentData([]); setAppliedStatus(null);
        setSelectedStudents([]); setSelectAll(false);
        setCourseTabData([]); setSelectedCourses([]); setSelectAllCourses(false);
        setCoursesData([]);
    };

    const showStudentList = async () => {
        if (!selectedAdmissionYearID) {
            toast.error("Please select Admission Year");
            return;
        }
        setLoading(true);
        setStudentData([]);
        setSelectedStudents([]);
        setSelectAll(false);
        setCourseTabData([]);
        setSelectedCourses([]);
        setSelectAllCourses(false);

        try {
            const response = await http.get('/College/getACA16ExternalCreditList', {
                params: {
                    admissionyear: selectedAdmissionYearID,
                    college_id: changedCollegesId || null,
                    discipline_id: changedDisciplineId || null,
                    status: selectedStatus ? [selectedStatus.value] : null,
                }
            });
            if (response.data.status_code === "ERR5") {
                toast.error("Data not found");
            }

            setStudentData(response.data.applications || []);
            setPendingApplications(response.data.pending_applications || []);
            setCourseTabData(response.data.courses || []);
            setAppliedStatus(selectedStatus || null);
            await fetchStatuses();

            if (selectedStatus) {
                setActiveTab('filtered');
            } else {
                setActiveTab('pending');
            }

        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => navigate("/admin/"), 5000);
            }

            if (error.response?.data?.http_status === 401 && error.response?.data?.status_code == "ERR9") {
                toast.error("Invalid Token");
                setTimeout(() => navigate("/admin/"), 5000);
            }
            else if (status === 401) {
                toast.error(data?.message || "Invalid Token");
                setTimeout(() => navigate("/admin/"), 3000);
            }
            else if (error.response?.data?.http_status === 429 && error.response?.data?.status_code === "ERR33") {
                toast.error(error.response.data.message);
            }
            else {
                toast.error(error.response?.data?.message || "Error fetching data");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSearchInputChange = (e) => { setSearchQuery(e.target.value); setCurrentPage(1); };

    const handleSort = (column) => {
        setSortBy({
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        });
    };

    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc'
                ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i>
                : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>;
    };

    const handleNextPage = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };
    const handlePreviousPage = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };
    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const isEligibleForSelection = (student) => {
        const lockedStatuses = ['application_approved', 'rejected_by_aca16', 'bos_course_rejected'];
        if (lockedStatuses.includes(student.application_status)) return false;
        return student.application_status === 'forwarded_to_university' || student.application_status === 'bos_course_approved';
    };

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        setSelectedStudents(checked
            ? filteredAndSortedData.filter(s => isEligibleForSelection(s)).map(s => s.id)
            : []
        );
    };

    const handleSelectStudent = (studentId) => {
        const student = filteredAndSortedData.find(s => s.id === studentId);
        if (!student || !isEligibleForSelection(student)) return;
        setSelectedStudents(prev =>
            prev.includes(studentId) ? prev.filter(id => id !== studentId) : [...prev, studentId]
        );
    };

    useEffect(() => {
        const eligibleIds = filteredAndSortedData.filter(s => isEligibleForSelection(s)).map(s => s.id);
        if (eligibleIds.length === 0) { setSelectAll(false); return; }
        setSelectAll(eligibleIds.every(id => selectedStudents.includes(id)));
    }, [selectedStudents, filteredAndSortedData]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
        setSelectedStudents([]); setSelectAll(false);
        setSelectedCourses([]); setSelectAllCourses(false);
    };

    const openEditModal = (item, role) => {
        setSelectedAccountId(item.accountid);
        setSelectedCreditId(item.id);
        setSelectedRole(role);
        setShowEditModal(true);
    };

    const refreshDataAfterUpdate = async () => {
        await showStudentList();
        setReload(prev => !prev);
    };

    // ── Update Application Status ─────────────────────────────────────────────
    const handleUpdateStatus = async (creditIds, status, actionName) => {
        const idsArray = Array.isArray(creditIds) ? creditIds : [creditIds];
        if (idsArray.length === 0) { toast.error("Please select at least one student"); return; }

        const getHtmlContent = (count, actionText) => `
            <div style="text-align: left; padding: 5px 0;">
                <p style="margin: 0 0 16px 0; font-size: 15px; color: #4b5563; line-height: 1.5;">
                    ${count > 1
                ? `Are you sure you want to <strong>${actionText}</strong> ${count} selected application(s)?`
                : `Are you sure you want to <strong>${actionText}</strong> this application?`}
                </p>
                <div style="position: relative;">
                    <textarea id="customRemarks"
                        placeholder="Enter remarks (required)..."
                        style="width: 100%; min-height: 90px; padding: 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; font-family: inherit; color: #1f2937; background-color: #f9fafb; resize: vertical; box-sizing: border-box; outline: none; transition: all 0.2s ease-in-out;"
                        onfocus="this.style.borderColor='#3b82f6'; this.style.backgroundColor='#ffffff'; this.style.boxShadow='0 0 0 3px rgba(59, 130, 246, 0.15)';"
                        onblur="this.style.borderColor='#d1d5db'; this.style.backgroundColor='#f9fafb'; this.style.boxShadow='none';"
                    ></textarea>
                </div>
            </div>
        `;

        const remarksPreConfirm = () => {
            const remarks = document.getElementById('customRemarks').value.trim();
            if (!remarks) {
                toast.error('Remarks are required to proceed!');
                return false;
            }
            return { remarks };
        };

        const swalConfig = {
            application_approved: {
                title: 'Approve Application?',
                html: `<div style="text-align: left; padding: 5px 0; font-size: 15px; color: #4b5563;">
                        ${idsArray.length > 1
                        ? `Are you sure you want to approve <strong>${idsArray.length}</strong> selected application(s)?`
                        : 'Are you sure you want to approve this application?'}
                       </div>`,
                icon: 'question',
                confirmButtonText: 'Yes, Approve',
                confirmButtonColor: '#10b981',
            },
            rejected_by_aca16: {
                title: 'Reject Application',
                html: getHtmlContent(idsArray.length, 'reject'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Reject',
                confirmButtonColor: '#ef4444',
                preConfirm: remarksPreConfirm
            },
            reverted_to_student: {
                title: 'Revert to Student',
                html: getHtmlContent(idsArray.length, 'revert'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Revert',
                confirmButtonColor: '#f97316',
                preConfirm: remarksPreConfirm
            },
        };

        const config = swalConfig[status] || {
            title: 'Confirm Action?',
            html: `<div style="text-align: left; padding: 5px 0; font-size: 15px; color: #4b5563;">Are you sure you want to perform this action?</div>`,
            icon: 'question',
            confirmButtonText: 'Yes, Proceed',
            confirmButtonColor: '#3b82f6',
        };

        const result = await Swal.fire({
            title: config.title,
            html: config.html,
            icon: config.icon,
            showCancelButton: true,
            confirmButtonColor: config.confirmButtonColor,
            cancelButtonColor: '#f3f4f6',
            confirmButtonText: config.confirmButtonText,
            cancelButtonText: '<span style="color: #4b5563; font-weight: 500;">Cancel</span>',
            reverseButtons: true,
            customClass: { popup: 'swal-custom-popup' },
            preConfirm: config.preConfirm,
        });

        if (!result.isConfirmed) return;

        setLoading(true);
        try {
            const response = await http.post('/College/updateExternalCreditStatus', {
                credit_ids: idsArray,
                status,
                remarks: result.value?.remarks || '',
            });

            if (response.data.status) {
                await Swal.fire({
                    title: 'Done!', text: response.data.message, icon: 'success',
                    confirmButtonColor: '#10b981', timer: 600, timerProgressBar: true, showConfirmButton: false,
                    customClass: { popup: 'swal-custom-popup' }
                });
                setSelectedStudents([]); setSelectAll(false);
                await showStudentList();
            } else {
                Swal.fire({ title: 'Failed', text: response.data.message, icon: 'error', confirmButtonColor: '#ef4444', customClass: { popup: 'swal-custom-popup' } });
                setLoading(false);
            }
        } catch (error) {
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                Swal.fire({ title: 'Session Expired', text: 'Your session has expired. Please log in again.', icon: 'error', confirmButtonColor: '#ef4444', customClass: { popup: 'swal-custom-popup' } });
                setTimeout(() => navigate("/admin/"), 3000);
            } else {
                Swal.fire({ title: 'Error', text: error.response?.data?.message || `Error processing ${actionName.toLowerCase()}`, icon: 'error', confirmButtonColor: '#ef4444', customClass: { popup: 'swal-custom-popup' } });
            }
            setLoading(false);
        }
    };

    // ── Update Course Status ──────────────────────────────────────────────────
    const handleUpdateCourseStatus = async (courseIds, action, actionName) => {
        const idsArray = Array.isArray(courseIds) ? courseIds : [courseIds];
        if (idsArray.length === 0) { toast.error("Please select at least one course"); return; }

        const swalConfig = {
            forward: {
                title: 'Forward to BOS?',
                html: `<div style="text-align: left; padding: 5px 0; font-size: 15px; color: #4b5563;">Are you sure you want to forward <strong>${idsArray.length}</strong> course(s) to BOS?</div>`,
                icon: 'question',
                confirmButtonText: 'Yes, Forward',
                confirmButtonColor: '#8b5cf6',
            },
            approve: {
                title: 'Approve Course?',
                html: `<div style="text-align: left; padding: 5px 0; font-size: 15px; color: #4b5563;">Are you sure you want to approve <strong>${idsArray.length}</strong> course(s)?<br/><br/><span style="font-size: 13px; color: #6c757d;">All pending student applications for these courses will be moved to BOS Approved.</span></div>`,
                icon: 'question',
                confirmButtonText: 'Yes, Approve',
                confirmButtonColor: '#10b981',
            },
            reject: {
                title: 'Reject Course?',
                html: `<div style="text-align: left; padding: 5px 0; font-size: 15px; color: #4b5563;">Are you sure you want to reject <strong>${idsArray.length}</strong> course(s)?</div>`,
                icon: 'warning',
                confirmButtonText: 'Yes, Reject',
                confirmButtonColor: '#ef4444',
            },
        };

        const config = swalConfig[action];

        const result = await Swal.fire({
            title: config.title,
            html: config.html,
            icon: config.icon,
            showCancelButton: true,
            confirmButtonColor: config.confirmButtonColor,
            cancelButtonColor: '#f3f4f6',
            confirmButtonText: config.confirmButtonText,
            cancelButtonText: '<span style="color: #4b5563; font-weight: 500;">Cancel</span>',
            reverseButtons: true,
            customClass: { popup: 'swal-custom-popup' },
        });

        if (!result.isConfirmed) return;

        setLoading(true);
        try {
            const response = await http.post('/College/updateCourseStatus', {
                course_ids: idsArray,
                action,
            });

            if (response.data.status) {
                await Swal.fire({
                    title: 'Done!', text: response.data.message, icon: 'success',
                    confirmButtonColor: '#10b981', timer: 600, timerProgressBar: true, showConfirmButton: false,
                    customClass: { popup: 'swal-custom-popup' }
                });
                setSelectedCourses([]);
                setSelectAllCourses(false);
                await showStudentList();
            } else {
                Swal.fire({ title: 'Failed', text: response.data.message, icon: 'error', confirmButtonColor: '#ef4444', customClass: { popup: 'swal-custom-popup' } });
                setLoading(false);
            }
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Something went wrong',
                icon: 'error', confirmButtonColor: '#ef4444',
                customClass: { popup: 'swal-custom-popup' }
            });
            setLoading(false);
        }
    };

    // ── Export Handlers ───────────────────────────────────────────────────────
    const handleExport = async ({ status, courseType, type }) => {
        if (!selectedAdmissionYearID) {
            toast.error("Please select Admission Year first");
            return;
        }
        setIsExporting(true);
        try {
            const response = await http.post(
                '/College/exportACA16ExternalCredit',
                {
                    admissionyear: selectedAdmissionYearID,
                    college_id: changedCollegesId || null,
                    discipline_id: changedDisciplineId || null,
                    courseType: courseType ?? 'all',
                    type,
                    status: status || [],
                },
                { responseType: 'blob' }
            );
            const contentType = response.headers['content-type'] || '';
            if (contentType.includes('application/json')) {
                const text = await response.data.text();
                const parsed = JSON.parse(text);
                toast.error(parsed.message || 'No data found');
                return;
            }
            const disposition = response.headers['content-disposition'] || '';
            const match = disposition.match(/filename="?([^";\n]+)"?/);
            const fileName = match ? match[1] : `external_credit_${Date.now()}.${type === 'excel' ? 'xlsx' : 'pdf'}`;
            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url; link.download = fileName;
            document.body.appendChild(link); link.click(); link.remove();
            window.URL.revokeObjectURL(url);
            setShowExportModal(false);
            toast.success(`${type === 'excel' ? 'Excel' : 'PDF'} exported successfully`);
        } catch (error) {
            if (error.response?.data) {
                try {
                    const text = await error.response.data.text();
                    const parsed = JSON.parse(text);
                    if (parsed.http_status === 403) { toast.error("Invalid Token"); setTimeout(() => navigate("/admin/"), 5000); }
                    else toast.error(parsed.message || `Error exporting ${type.toUpperCase()}`);
                } catch { toast.error(`Error exporting ${type.toUpperCase()}`); }
            } else {
                toast.error(`Error exporting ${type.toUpperCase()}`);
            }
        } finally {
            setIsExporting(false);
        }
    };

    const handleDirectCoursesPdfDownload = async () => {
        setIsExportingCoursesDirect(true);
        try {
            const response = await http.post(
                '/College/exportACA16ExternalCourses',
                { type: 'pdf', status: ['verified'] },
                { responseType: 'blob' }
            );
            const contentType = response.headers['content-type'] || '';
            const disposition = response.headers['content-disposition'] || '';
            const match = disposition.match(/filename="?([^";\n]+)"?/);
            const fileName = match ? match[1] : `approved_courses_${Date.now()}.pdf`;
            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url; link.download = fileName;
            document.body.appendChild(link); link.click(); link.remove();
            window.URL.revokeObjectURL(url);
            toast.success("PDF downloaded successfully");
        } catch (error) {

            const status = error.response?.status;
            const data = error.response?.data;
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => navigate("/admin/"), 5000);
            }

            if (error.response?.data?.http_status === 401 && error.response?.data?.status_code == "ERR9") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/admin/");
                }, 5000);

            }
            else if (status === 401) {
                toast.error(data?.message || "Invalid Token");

                setTimeout(() => {
                    navigate("/admin/");
                }, 3000);
            }

            else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                toast.error(error.response.data.message);
            }
            else {
                toast.error(error.response?.data?.message || "Error fetching data");
            }

            toast.error("Error downloading PDF");
        } finally {
            setIsExportingCoursesDirect(false);
        }
    };


    const handleExcelDownload = async () => {
        setIsExportingExcel(true);
        try {
            const response = await http.post(
                '/College/exportACA16ExternalCourses',
                { type: 'excel', status: ['verified'] },
                { responseType: 'blob' }
            );
            const contentType = response.headers['content-type'] || '';
            const disposition = response.headers['content-disposition'] || '';
            const match = disposition.match(/filename="?([^";\n]+)"?/);
            const fileName = match ? match[1] : `approved_courses_${Date.now()}.xlsx`;
            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url; link.download = fileName;
            document.body.appendChild(link); link.click(); link.remove();
            window.URL.revokeObjectURL(url);
            toast.success("Excel downloaded successfully");
        } catch (error) {

            const status = error.response?.status;
            const data = error.response?.data;
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => navigate("/admin/"), 5000);
            }

            if (error.response?.data?.http_status === 401 && error.response?.data?.status_code == "ERR9") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/admin/");
                }, 5000);

            }
            else if (status === 401) {
                toast.error(data?.message || "Invalid Token");

                setTimeout(() => {
                    navigate("/admin/");
                }, 3000);
            }

            else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                toast.error(error.response.data.message);
            }
            else {
                toast.error(error.response?.data?.message || "Error fetching data");
            }

            toast.error("Error downloading Excel");
        } finally {
            setIsExportingExcel(false);
        }
    };

    // ── Tab style helper ──────────────────────────────────────────────────────
    const tabStyle = (tabKey) => ({
        cursor: 'pointer',
        padding: '14px 16px',
        fontSize: '13px',
        fontWeight: activeTab === tabKey ? 600 : 400,
        color: activeTab === tabKey ? 'var(--bs-primary)' : '#6c757d',
        boxShadow: activeTab === tabKey ? 'inset 0 -2px 0 var(--bs-primary)' : 'none',
        display: 'flex', alignItems: 'center', gap: '6px',
        transition: 'all 0.15s ease',
        userSelect: 'none', whiteSpace: 'nowrap', flexShrink: 0,
    });

    const tabBadgeStyle = (tabKey) => ({
        background: activeTab === tabKey ? '#e8f0fe' : '#f0f1f2',
        color: activeTab === tabKey ? 'var(--bs-primary)' : '#6c757d',
        borderRadius: '10px', padding: '1px 8px', fontSize: '11px', fontWeight: 500,
    });

    const appStatusBgMap = {
        forwarded_to_university: '#0d6efd',
        forwarded_to_bos: '#6f42c1',
        bos_course_approved: '#fd7e14',
        bos_course_rejected: '#dc3545',
        application_approved: '#28a745',
        rejected_by_aca16: '#dc3545',
        reverted_to_student: '#6c757d',
    };

    const hasData = studentData.length > 0 || courseTabData.length > 0;

    return (
        <>
            {/* Added custom Swal styles to enforce new aesthetics globally across this component */}
            <style dangerouslySetInnerHTML={{
                __html: `
                .swal-custom-popup { border-radius: 16px !important; padding-bottom: 24px !important; font-family: inherit !important; }
                .swal-custom-popup .swal2-html-container { margin: 1em 1.6em 0.3em !important; overflow: hidden !important; }
                .swal-custom-popup .swal2-actions { margin-top: 1.5em !important; gap: 12px; }
                .swal-custom-popup .swal2-confirm, .swal-custom-popup .swal2-cancel { border-radius: 8px !important; padding: 10px 24px !important; font-weight: 500 !important; font-size: 14.5px !important; }
            `}} />
            <ToastContainer />
            <Template>
                {loading ? (
                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                        <div className="containeranimate">
                                            {[...Array(8)].map((_, i) => <div key={i} className="dot"></div>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="col-md-12">
                                        <div className="card-header">
                                            <div className="py-3 d-flex justify-content-between align-items-center">
                                                <h5 style={{ margin: 0 }}>Student External Credit Applications</h5>
                                            </div>
                                        </div>

                                        <div className="card-body pdg">
                                            <div className="card-body">
                                                {/* ── Filter Row ── */}
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label>Admission Year <span className="errorclr">*</span></label>
                                                        <Select
                                                            maxMenuHeight={200} menuPlacement="auto"
                                                            placeholder="Select" className="form" styles={customStyles}
                                                            options={admissionYears} value={selectedAdmissionYear}
                                                            onChange={handleAdmissionYearChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>Discipline</label>
                                                        <Select
                                                            maxMenuHeight={200} menuPlacement="auto"
                                                            placeholder="Select Discipline" className="form" styles={customStyles}
                                                            value={changedDisciplineData}
                                                            options={getDisciplinesData.map(d => ({ value: d.discipline_id, label: d.discipline_name }))}
                                                            onChange={handleDisciplineChange}
                                                            isDisabled={!selectedAdmissionYearID}
                                                            isClearable
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>College</label>
                                                        <Select
                                                            maxMenuHeight={200} menuPlacement="auto"
                                                            placeholder="Select College" className="form" styles={customStyles}
                                                            value={changedCollegeData}
                                                            options={getCollegesData.map(c => ({ value: c.college_id, label: c.college_name }))}
                                                            onChange={handleCollegeChange}
                                                            isDisabled={!selectedAdmissionYearID}
                                                            isClearable
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>Application Status</label>
                                                        <Select
                                                            maxMenuHeight={200} menuPlacement="auto"
                                                            placeholder="Filter by Status" className="form" styles={customStyles}
                                                            value={selectedStatus} options={statusOptions}
                                                            onChange={handleStatusChange}
                                                            isClearable isDisabled={!selectedAdmissionYearID}
                                                        />
                                                    </div>
                                                    <div className="justify-content-end">
                                                        <div className="d-flex justify-content-end gap-2" style={{ marginTop: '28px' }}>
                                                            {selectedAdmissionYearID && (
                                                                <button
                                                                    className="btn btn-primary action-btn d-inline-flex align-items-center gap-2"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setShowCoursesModal(true);
                                                                        fetchApprovedCourses();
                                                                    }}
                                                                    title="View Approved Courses"
                                                                >
                                                                    <i className="bi bi-patch-check-fill"></i>
                                                                    <span className="d-none d-md-inline">Approved Courses</span>
                                                                </button>
                                                            )}
                                                            <button type="button" className="btn btn-primary action-btn" onClick={showStudentList}>Go</button>
                                                            <button type="button" className="btn btn-secondary clear-btn btn-sm" onClick={handleClearFields}>Clear</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* ── Data Section ── */}
                                            {hasData && (
                                                <div className="form theme-form">
                                                    <div className="custom-input">
                                                        <div className="card-body">
                                                            <div className="pdg1" style={{ border: '1px solid #dee2e6', borderRadius: '10px', overflow: 'hidden', background: '#fff' }}>

                                                                {/* ── Tab Bar ── */}
                                                                <div style={{ background: '#fff', borderBottom: '2px solid #dee2e6', display: 'flex', overflowX: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>

                                                                    {/* Applications Tab */}
                                                                    <div
                                                                        onClick={() => handleTabChange('pending')}
                                                                        style={tabStyle('pending')}
                                                                    >
                                                                        <i className="bi bi-file-earmark-person-fill" style={{ fontSize: '12px' }} />
                                                                        Applications Pending
                                                                        <span style={tabBadgeStyle('pending')}>
                                                                            {pendingApplications.length}
                                                                        </span>
                                                                    </div>

                                                                    {/* Course Pending Tab */}
                                                                    <div onClick={() => handleTabChange('course_pending')} style={tabStyle('course_pending')}>
                                                                        <i className="bi bi-journal-check" style={{ fontSize: '12px' }} />
                                                                        Course Pending
                                                                        <span style={tabBadgeStyle('course_pending')}>
                                                                            {courseTabData.filter(c => c.verification_status === 'entered').length}
                                                                        </span>
                                                                    </div>

                                                                    <div onClick={() => handleTabChange('application')} style={tabStyle('application')}>
                                                                        <i className="bi bi-view-stacked" style={{ fontSize: '12px' }} />
                                                                        All Applications
                                                                        <span style={tabBadgeStyle('application')}>{studentData.length}</span>
                                                                    </div>

                                                                    {/* Filtered Results Tab — only when status filter applied */}
                                                                    {appliedStatus && (
                                                                        <div onClick={() => handleTabChange('filtered')} style={tabStyle('filtered')}>
                                                                            <i className="bi bi-funnel-fill" style={{ fontSize: '12px' }} />
                                                                            Filtered Results
                                                                            <span style={tabBadgeStyle('filtered')}>{studentData.length}</span>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                { }
                                                                {/* ── Table Content ── */}
                                                                <div style={{ padding: '16px', background: '#fff' }}>

                                                                    {(activeTab === 'pending' || activeTab === 'application' || activeTab === 'filtered') && (
                                                                        <div className="table-responsive">
                                                                            <div className='row mt-2 mb-2'>
                                                                                <div className='col-md-6 wdt'>
                                                                                    <p>Showing {(currentPage - 1) * 50 + 1} - {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries</p>
                                                                                </div>
                                                                                <div className='col-md-6 wdt' style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '7px' }}>
                                                                                    <input
                                                                                        type="text" value={searchQuery}
                                                                                        onChange={handleSearchInputChange}
                                                                                        placeholder="Search..." className='form-control'
                                                                                        style={{ maxWidth: '320px' }}
                                                                                    />
                                                                                    <button
                                                                                        className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                                                                                        type="button" onClick={() => setShowExportModal(true)} title="Download Report"
                                                                                    >
                                                                                        <i className="bi bi-arrow-down-square ctm-btn-sz"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            {/* Bulk Actions */}
                                                                            {selectedStudents.length > 0 && (
                                                                                <div className="mb-3 d-flex gap-2 align-items-center flex-wrap">
                                                                                    {(() => {
                                                                                        const selectedItems = filteredAndSortedData.filter(s => selectedStudents.includes(s.id));
                                                                                        const approvableIds = selectedItems.filter(s => s.application_status === 'bos_course_approved').map(s => s.id);
                                                                                        const rejectableIds = selectedItems.filter(s => s.application_status === 'forwarded_to_university' && s.course_approval_status === 'pending').map(s => s.id);

                                                                                        return (
                                                                                            <>
                                                                                                {approvableIds.length > 0 && (
                                                                                                    <button type="button"
                                                                                                        style={{ background: '#fff', border: '1px solid #198754', color: '#198754', borderRadius: '6px', padding: '5px 12px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 500, transition: 'all 0.15s ease' }}
                                                                                                        onMouseEnter={e => { e.currentTarget.style.background = '#198754'; e.currentTarget.style.color = '#fff'; }}
                                                                                                        onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#198754'; }}
                                                                                                        onClick={() => handleUpdateStatus(approvableIds, 'application_approved', 'Bulk approved')}
                                                                                                    >
                                                                                                        <i className="bi bi-check-circle-fill" style={{ fontSize: '12px' }}></i>
                                                                                                        Approve Selected ({approvableIds.length})
                                                                                                    </button>
                                                                                                )}
                                                                                                {rejectableIds.length > 0 && (
                                                                                                    <button type="button"
                                                                                                        style={{ background: '#fff', border: '1px solid #fd7e14', color: '#fd7e14', borderRadius: '6px', padding: '5px 12px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 500, transition: 'all 0.15s ease' }}
                                                                                                        onMouseEnter={e => { e.currentTarget.style.background = '#fd7e14'; e.currentTarget.style.color = '#fff'; }}
                                                                                                        onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#fd7e14'; }}
                                                                                                        onClick={() => handleUpdateStatus(rejectableIds, 'reverted_to_student', 'Bulk reverted')}
                                                                                                    >
                                                                                                        <i className="bi bi-arrow-counterclockwise" style={{ fontSize: '12px' }}></i>
                                                                                                        Revert to Student ({rejectableIds.length})
                                                                                                    </button>
                                                                                                )}
                                                                                                {rejectableIds.length > 0 && (
                                                                                                    <button type="button"
                                                                                                        style={{ background: '#fff', border: '1px solid #dc3545', color: '#dc3545', borderRadius: '6px', padding: '5px 12px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 500, transition: 'all 0.15s ease' }}
                                                                                                        onMouseEnter={e => { e.currentTarget.style.background = '#dc3545'; e.currentTarget.style.color = '#fff'; }}
                                                                                                        onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#dc3545'; }}
                                                                                                        onClick={() => handleUpdateStatus(rejectableIds, 'rejected_by_aca16', 'Bulk rejected')}
                                                                                                    >
                                                                                                        <i className="bi bi-x-circle-fill" style={{ fontSize: '12px' }}></i>
                                                                                                        Reject Selected ({rejectableIds.length})
                                                                                                    </button>
                                                                                                )}
                                                                                            </>
                                                                                        );
                                                                                    })()}
                                                                                </div>
                                                                            )}

                                                                            {/* Application Table */}
                                                                            <table className="display dataTable table-striped table-bordered ex-v-table" ref={tableRef}>
                                                                                <thead>
                                                                                    <tr className="bg-primary">
                                                                                        <th style={{ width: '50px' }}>
                                                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                                                                                            </div>
                                                                                        </th>
                                                                                        <th>Sl No</th>
                                                                                        <th onClick={() => handleSort('studentname')} style={{ textAlign: 'left', verticalAlign: 'middle', cursor: 'pointer' }}>
                                                                                            Name / PRN {renderSortIcon('studentname')}
                                                                                        </th>
                                                                                        <th onClick={() => handleSort('course_name')} style={{ textAlign: 'left', verticalAlign: 'middle', cursor: 'pointer' }}>
                                                                                            Course Name {renderSortIcon('course_name')}
                                                                                        </th>
                                                                                        <th onClick={() => handleSort('acquired_credits')} style={{ textAlign: 'center', verticalAlign: 'middle', cursor: 'pointer' }}>
                                                                                            Credits {renderSortIcon('acquired_credits')}
                                                                                        </th>
                                                                                        <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>Course Approval</th>
                                                                                        <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>Status</th>
                                                                                        <th style={{ textAlign: 'center', verticalAlign: 'middle' }}>Action</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {filteredAndSortedData.length > 0 ? (
                                                                                        filteredAndSortedData.map((item, index) => {
                                                                                            const serialNumber = (currentPage - 1) * 50 + index + 1;
                                                                                            const isSelected = selectedStudents.includes(item.id);
                                                                                            return (
                                                                                                <tr key={item.id}>
                                                                                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                            <input
                                                                                                                type="checkbox" checked={isSelected}
                                                                                                                onChange={() => handleSelectStudent(item.id)}
                                                                                                                disabled={!isEligibleForSelection(item)}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{serialNumber}</td>
                                                                                                    <td style={{ verticalAlign: 'middle' }}>
                                                                                                        <div style={{ fontWeight: 600, fontSize: '13px', color: '#212529' }}>{item.studentname}</div>
                                                                                                        <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '2px' }}>{item.prn}</div>
                                                                                                    </td>
                                                                                                    <td style={{ verticalAlign: 'middle', fontSize: '13px' }}>{item.course_name}</td>
                                                                                                    <td style={{ textAlign: 'center', verticalAlign: 'middle', fontWeight: 600, fontSize: '13px' }}>{item.acquired_credits}</td>
                                                                                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                        <span style={{
                                                                                                            background: item.course_approval_status === 'approved' ? '#20c997' : item.course_approval_status === 'pending' ? '#dc3545' : '#ffc107',
                                                                                                            color: '#fff', padding: '4px 10px', borderRadius: '12px',
                                                                                                            fontSize: '11px', fontWeight: 600, textTransform: 'capitalize',
                                                                                                        }}>
                                                                                                            {item.course_approval_status_label}
                                                                                                        </span>
                                                                                                    </td>
                                                                                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                        <span style={{
                                                                                                            background: appStatusBgMap[item.application_status] || '#6c757d',
                                                                                                            color: '#fff', borderRadius: '20px', padding: '3px 10px',
                                                                                                            fontSize: '11px', fontWeight: 600, whiteSpace: 'nowrap',
                                                                                                        }}>
                                                                                                            {item.application_status_label}
                                                                                                        </span>
                                                                                                    </td>
                                                                                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                            <ActionDropdown
                                                                                                                item={item}
                                                                                                                onView={openViewModal}
                                                                                                                onEdit={openEditModal}
                                                                                                                onUpdateStatus={handleUpdateStatus}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            );
                                                                                        })
                                                                                    ) : (
                                                                                        <tr><td colSpan="8" className="text-center py-3">No Data Found</td></tr>
                                                                                    )}
                                                                                </tbody>
                                                                            </table>

                                                                            {/* Pagination */}
                                                                            {totalPages > 1 && (
                                                                                <nav aria-label="..." style={{ cursor: 'pointer' }}>
                                                                                    <ul className="pagination justify-content-center mt-3">
                                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                                            <span className="page-link pgn-clr" onClick={handlePreviousPage}><i className="bi bi-arrow-left-circle-fill"></i></span>
                                                                                        </li>
                                                                                        <li className="page-item"><span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span></li>
                                                                                        {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                                        {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map(pageNumber => (
                                                                                            <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                                                            </li>
                                                                                        ))}
                                                                                        {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                                        {totalPages > 1 && <li className="page-item"><span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span></li>}
                                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                                            <span className="page-link pgn-clr" onClick={handleNextPage}><i className="bi bi-arrow-right-circle-fill"></i></span>
                                                                                        </li>
                                                                                    </ul>
                                                                                </nav>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    { }
                                                                    {/* ── COURSE PENDING TAB ── */}
                                                                    {activeTab === 'course_pending' && (
                                                                        <div>
                                                                            {courseTabLoading ? (
                                                                                <div className="d-flex justify-content-center py-5">
                                                                                    <div className="containeranimate">
                                                                                        {[...Array(4)].map((_, i) => <div key={i} className="dot"></div>)}
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <>
                                                                                    {/* Course Bulk Actions */}
                                                                                    {selectedCourses.length > 0 && (
                                                                                        <div className="mb-3 d-flex gap-2 flex-wrap">
                                                                                            {courseTabData.some(c => selectedCourses.includes(c.course_id) && c.verification_status === 'entered') && (
                                                                                                <button type="button"
                                                                                                    style={{ background: '#fff', border: '1px solid #6f42c1', color: '#6f42c1', borderRadius: '6px', padding: '5px 12px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 500 }}
                                                                                                    onMouseEnter={e => { e.currentTarget.style.background = '#6f42c1'; e.currentTarget.style.color = '#fff'; }}
                                                                                                    onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#6f42c1'; }}
                                                                                                    onClick={() => handleUpdateCourseStatus(
                                                                                                        courseTabData.filter(c => selectedCourses.includes(c.course_id) && c.verification_status === 'entered').map(c => c.course_id),
                                                                                                        'forward', 'Forward to BOS'
                                                                                                    )}
                                                                                                >
                                                                                                    <i className="bi bi-send-fill" style={{ fontSize: '12px' }}></i>
                                                                                                    Forward to BOS ({courseTabData.filter(c => selectedCourses.includes(c.course_id) && c.verification_status === 'entered').length})
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    )}

                                                                                    <div className="table-responsive">
                                                                                        <table className="display dataTable table-striped table-bordered ex-v-table">
                                                                                            <thead>
                                                                                                <tr className="bg-primary">
                                                                                                    <th style={{ width: '50px' }}>
                                                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                            <input
                                                                                                                type="checkbox" checked={selectAllCourses}
                                                                                                                onChange={(e) => {
                                                                                                                    setSelectAllCourses(e.target.checked);
                                                                                                                    setSelectedCourses(e.target.checked
                                                                                                                        ? courseTabData.filter(c => c.verification_status === 'entered').map(c => c.course_id)
                                                                                                                        : []
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </th>
                                                                                                    <th>Sl No</th>
                                                                                                    <th style={{ textAlign: 'left' }}>Course Name</th>
                                                                                                    <th style={{ textAlign: 'center' }}>Credits</th>
                                                                                                    <th style={{ textAlign: 'center' }}>Category</th>
                                                                                                    <th style={{ textAlign: 'center' }}>Student Count</th>
                                                                                                    <th style={{ textAlign: 'center' }}>Status</th>
                                                                                                    <th style={{ textAlign: 'center' }}>Action</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {courseTabData.length === 0 ? (
                                                                                                    <tr><td colSpan="8" className="text-center py-3">No courses found</td></tr>
                                                                                                ) : courseTabData.map((course, index) => {
                                                                                                    const isBosApproved = course.verification_status === 'verified';
                                                                                                    const isForwardedToBos = course.verification_status === 'forwarded';
                                                                                                    const isSelected = selectedCourses.includes(course.course_id);
                                                                                                    return (
                                                                                                        <tr key={course.course_id}>
                                                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                                    <input
                                                                                                                        type="checkbox" checked={isSelected}
                                                                                                                        disabled={isBosApproved || isForwardedToBos}
                                                                                                                        onChange={() => {
                                                                                                                            setSelectedCourses(prev =>
                                                                                                                                prev.includes(course.course_id)
                                                                                                                                    ? prev.filter(id => id !== course.course_id)
                                                                                                                                    : [...prev, course.course_id]
                                                                                                                            );
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{index + 1}</td>
                                                                                                            <td style={{ verticalAlign: 'middle', fontWeight: 500, fontSize: '13px' }}>{course.course_name}</td>
                                                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle', fontWeight: 600, fontSize: '13px' }}>{course.credit}</td>
                                                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                                <code style={{ color: '#581f37', fontWeight: 600 }}>{course.category_code}</code>
                                                                                                            </td>
                                                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle', fontWeight: 600, fontSize: '13px' }}>{course.student_count}</td>
                                                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                                <span style={{
                                                                                                                    background: isBosApproved ? '#d1e7dd' : isForwardedToBos ? '#e8d5f5' : '#fff3cd',
                                                                                                                    color: isBosApproved ? '#0f5132' : isForwardedToBos ? '#6f42c1' : '#856404',
                                                                                                                    padding: '3px 10px', borderRadius: '20px',
                                                                                                                    fontSize: '11px', fontWeight: 600, whiteSpace: 'nowrap',
                                                                                                                    border: `1px solid ${isBosApproved ? '#badbcc' : isForwardedToBos ? '#d0b0f0' : '#ffecb5'}`,
                                                                                                                }}>
                                                                                                                    {course.verification_status.toUpperCase()}
                                                                                                                </span>
                                                                                                            </td>
                                                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                                                <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                                                                                                    {course.verification_status === 'entered' && (
                                                                                                                        <ActionBtn
                                                                                                                            onClick={() => handleUpdateCourseStatus(course.course_id, 'forward', 'Forward to BOS')}
                                                                                                                            title="Forward to BOS"
                                                                                                                            borderColor="#6f42c1"
                                                                                                                            icon="bi bi-send-fill"
                                                                                                                        />
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                })}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <ViewApplicationModal
                    showViewModal={showViewModal} closeViewModal={closeViewModal}
                    viewData={viewData} viewLoading={viewLoading} pdfLoading={pdfLoading}
                    pdfModal={pdfModal} openPdfModal={openPdfModal} closePdfModal={closePdfModal}
                />
            </Template>

            <PDFModal
                isOpen={pdfModal.show} onClose={closePdfModal}
                pdfUrl={pdfModal.url} fileName={pdfModal.name} fileType={pdfModal.type}
            />

            <ViewExternalCreditApplicationUpdate
                showEditModal={showEditModal}
                closeEditModal={() => { setShowEditModal(false); setSelectedAccountId(null); setSelectedCreditId(null); setSelectedRole(""); }}
                accountId={selectedAccountId} creditId={selectedCreditId}
                role={selectedRole} http={http} onRefreshData={refreshDataAfterUpdate}
            />

            <ExportExternalCreditModal
                show={showExportModal}
                onClose={() => setShowExportModal(false)}
                onExportStudents={handleExport}
                isExporting={isExporting}
                exportType="students"
            />

            { }
            {/* ── Approved Courses Modal ── */}
            {showCoursesModal && (
                <>
                    <div
                        className="modal-backdrop show"
                        style={{ zIndex: 1050, backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
                        onClick={() => !isExportingCoursesDirect && !isExportingExcel && setShowCoursesModal(false)}
                    />
                    <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1055, pointerEvents: 'none' }}>
                        <div style={{
                            position: 'fixed', top: '50%', left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 'min(1000px, 95vw)',
                            maxHeight: 'min(700px, 80vh)',
                            display: 'flex', flexDirection: 'column',
                            background: '#fff', borderRadius: 16,
                            overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
                            pointerEvents: 'auto',
                        }}>
                            {/* Header */}
                            <div style={{ background: '#581f37', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                    <div style={{ width: 42, height: 42, borderRadius: 10, background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(255,255,255,0.2)' }}>
                                        <i className="bi bi-patch-check-fill text-white" style={{ fontSize: 20 }} />
                                    </div>
                                    <div>
                                        <h5 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: '#fff' }}>Approved External Courses</h5>
                                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>
                                            <span className="badge" style={{ background: 'rgba(255,255,255,0.15)', fontWeight: 400 }}>
                                                {coursesData.length} Courses Available
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <button type="button" onClick={handleDirectCoursesPdfDownload} disabled={isExportingCoursesDirect}
                                        style={{ height: 38, padding: '0 16px', borderRadius: 8, background: '#fff', border: 'none', cursor: isExportingCoursesDirect ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, color: '#581f37', opacity: isExportingCoursesDirect ? 0.7 : 1 }}>
                                        {isExportingCoursesDirect ? <span className="spinner-border spinner-border-sm" role="status" /> : <i className="bi bi-cloud-arrow-down-fill" style={{ fontSize: 16 }} />}
                                        <span className="d-none d-md-inline">{isExportingCoursesDirect ? 'Processing...' : 'Export PDF'}</span>
                                    </button>
                                    <button onClick={handleExcelDownload} disabled={isExportingExcel}
                                        style={{ height: 38, padding: '0 16px', borderRadius: 8, background: '#1D6F42', border: 'none', cursor: isExportingExcel ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, color: '#fff', opacity: isExportingExcel ? 0.7 : 1 }}>
                                        {isExportingExcel ? <span className="spinner-border spinner-border-sm text-white" role="status" /> : <i className="bi bi-file-earmark-excel-fill" />}
                                        <span className="d-none d-sm-inline">{isExportingExcel ? 'Processing...' : 'Export Excel'}</span>
                                    </button>
                                    <button type="button" onClick={() => setShowCoursesModal(false)} disabled={isExportingCoursesDirect || isExportingExcel}
                                        style={{ width: 32, height: 32, borderRadius: '50%', background: 'rgba(0,0,0,0.2)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <i className="bi bi-x-lg text-white" style={{ fontSize: 14 }} />
                                    </button>
                                </div>
                            </div>

                            {/* Body */}
                            <div style={{ overflowY: 'auto', flex: 1, minHeight: 0, padding: '24px', backgroundColor: '#f8f9fa' }}>
                                {isLoadingCourses ? (
                                    <div style={{ textAlign: 'center', padding: '60px 0' }}>
                                        <div className="spinner-border text-primary" />
                                        <p style={{ marginTop: 12, color: '#6c757d' }}>Loading courses...</p>
                                    </div>
                                ) : coursesData.length === 0 ? (
                                    <div style={{ textAlign: 'center', padding: '60px 0' }}>
                                        <i className="bi bi-folder2-open" style={{ fontSize: 40, color: '#dee2e6' }} />
                                        <p style={{ marginTop: 12, color: '#6c757d', fontSize: 15 }}>No approved courses found.</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive" style={{ borderRadius: 8, boxShadow: '0 2px 12px rgba(0,0,0,0.04)', background: '#fff' }}>
                                        <table className="table table-hover mb-0" style={{ fontSize: 14 }}>
                                            <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                <tr>
                                                    <th className="bg-light" style={{ width: '40px', textAlign: 'center', borderTop: 'none', color: '#495057' }}>#</th>
                                                    <th className="bg-light" style={{ textAlign: 'center', borderTop: 'none', color: '#495057' }}>Course Name</th>
                                                    <th className="bg-light" style={{ textAlign: 'center', borderTop: 'none', color: '#495057' }}>Discipline</th>
                                                    <th className="bg-light" style={{ textAlign: 'center', width: '80px', borderTop: 'none', color: '#495057' }}>Credits</th>
                                                    <th className="bg-light" style={{ textAlign: 'center', width: '100px', borderTop: 'none', color: '#495057' }}>Category</th>
                                                    <th className="bg-light" style={{ textAlign: 'center', borderTop: 'none', color: '#495057' }}>Approved Authority</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {coursesData.map((course, index) => (
                                                    <tr key={course.course_id || index}>
                                                        <td style={{ textAlign: 'center', color: '#adb5bd' }}>
                                                            {index + 1}
                                                        </td>

                                                        <td style={{ fontWeight: 500, color: '#2d3436' }}>
                                                            {course.course_name}
                                                        </td>

                                                        <td style={{ textAlign: 'center', color: '#495057' }}>
                                                            {course.discipline_name}
                                                        </td>

                                                        <td style={{ textAlign: 'center' }}>
                                                            {course.credit}
                                                        </td>

                                                        <td style={{ textAlign: 'center' }}>
                                                            <code style={{ color: '#581f37', fontWeight: 600 }}>
                                                                {course.category_code}
                                                            </code>
                                                        </td>

                                                        <td style={{ textAlign: 'center', color: '#495057' }}>
                                                            <span style={{ fontSize: 13, color: '#6c757d' }}>
                                                                {course.approved_authority || '—'}
                                                            </span>                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div style={{ padding: '12px 24px', background: '#fff', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => setShowCoursesModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}